import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export const Quote = ({ text, author, authorRole }) => {
    const { quotationMark } = useStaticQuery(graphql`
        query {
            quotationMark: file(relativePath: { eq: "customerStories/quotation-mark.png" }) {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                }
            }
        }
    `);

    return (
        <div className="tw-not-prose tw-grid tw-grid-cols-[20px_minmax(0px,_1fr)] tw-items-start lg:tw-gap-24 tw-gap-12">
            <GatsbyImage image={getImage(quotationMark)} alt="Quotation Mark" objectFit="contain" />
            <blockquote>
                <p className="tw-font-bold lg:tw-text-2xl">{text}</p>
                {author && (
                    <div className="tw-flex tw-gap-8 sm:tw-items-center sm:tw-flex-row tw-flex-col tw-mt-24 tw-text-neutral-subdued">
                        <span className="tw-shrink-0">{author}</span>
                        <span className="sm:tw-inline-block tw-hidden tw-text-neutral-subdued">
                            |
                        </span>
                        <span className="tw-text-opacity-70">{authorRole}</span>
                    </div>
                )}
            </blockquote>
        </div>
    );
};
